module.exports = __webpack_public_path__ + "img/wellness.9e990341.png";